import { alpha, createStyles, makeStyles, Theme } from "@material-ui/core";

interface LynxButtonStylesProps {
    responsive: boolean;
}

export const lynxButtonStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            padding: theme.spacing("9px", 1),
            background: theme.colors.primary.blue500,
            color: theme.colors.neutrals.white,
            fontWeight: 500,
            ...theme.typography.subtitle1,
            lineHeight: "14px",
            width: ({ responsive }: LynxButtonStylesProps) =>
                responsive ? "100%" : "159px",

            "&:hover": {
                backgroundColor: theme.colors.primary.blue600,
            },

            "&:active": {
                backgroundColor: theme.colors.primary.blue600,
            },
        },

        small: {
            padding: theme.spacing("6px", 1),
            ...theme.typography.subtitle2,
            width: ({ responsive }: LynxButtonStylesProps) =>
                responsive ? "100%" : "124px",
        },

        large: {
            padding: theme.spacing("12px", 1),
            ...theme.typography.button,
            width: ({ responsive }: LynxButtonStylesProps) =>
                responsive ? "100%" : "180px",
        },

        focusVisible: {
            backgroundColor: theme.colors.primary.blue600,
            boxShadow: theme.focusShadow,
        },

        disabled: {
            backgroundColor: alpha(theme.colors.primary.blue500, 0.65),
            color: "white !important",
        },

        "@keyframes spin": {
            from: { transform: "rotate(0deg)" },
            to: { transform: "rotate(360deg)" },
        },

        spinner: {
            animation: "$spin 2s linear infinite",
        },
    })
);
